import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { siteContent } from '../data/mock';
import { Quote, Lightbulb } from 'lucide-react';

const TeachingsSection = () => {
  const { language } = useLanguage();
  const content = siteContent[language].teachings;

  return (
    <section id="teachings" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-orange-800 mb-4">
            {content.title}
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-600 max-w-2xl mx-auto">
            {content.subtitle}
          </p>
          <div className="mt-6 flex justify-center">
            <div className="w-24 h-1 bg-gradient-to-r from-orange-400 to-amber-400 rounded-full" />
          </div>
        </div>

        {/* Teachings Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {content.items.map((teaching, index) => (
            <div
              key={index}
              className="group relative p-5 md:p-6 bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl border border-orange-100 hover:border-orange-300 shadow-md hover:shadow-xl transition-all duration-300"
            >
              {/* Quote Icon */}
              <div className="absolute -top-3 -right-3 w-8 h-8 md:w-10 md:h-10 bg-gradient-to-br from-orange-400 to-amber-400 rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <Quote className="w-4 h-4 md:w-5 md:h-5 text-white" />
              </div>

              {/* Icon */}
              <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-orange-400 to-amber-400 rounded-xl flex items-center justify-center mb-4">
                <Lightbulb className="w-5 h-5 md:w-6 md:h-6 text-white" />
              </div>

              {/* Title */}
              <h3 className="text-lg md:text-xl font-bold text-orange-800 mb-3">
                {teaching.title}
              </h3>

              {/* Content */}
              <p className="text-gray-700 leading-relaxed mb-4 text-sm md:text-base">
                {teaching.content}
              </p>

              {/* Gujarati Version (only show in English mode) */}
              {language === 'en' && teaching.gujarati && (
                <div className="pt-4 border-t border-orange-200">
                  <p className="text-xs md:text-sm text-orange-600 italic">
                    {teaching.gujarati}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeachingsSection;
